import { render, staticRenderFns } from "./ChargeRoleDialog.vue?vue&type=template&id=074f12d6"
import script from "./ChargeRoleDialog.vue?vue&type=script&lang=js"
export * from "./ChargeRoleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports